module.exports = __webpack_public_path__ + "img/tea.d0efbcf6.svg";